// src/components/admin/UsuarioForm.jsx
import React, { useState } from 'react';

export default function UsuarioForm({ onCrearUsuario, msg }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmar, setConfirmar] = useState('');
  const [rol, setRol] = useState('employee');
  const [enviando, setEnviando] = useState(false);

  // ✅ nuevos opcionales
  const [nombre, setNombre] = useState('');
  const [apellido1, setApellido1] = useState('');
  const [apellido2, setApellido2] = useState('');
  const [horasSemanales, setHorasSemanales] = useState('');

  const [errors, setErrors] = useState({ email: '', password: '', confirmar: '', horas: '', general: '' });
  const [showPwd, setShowPwd] = useState(false);
  const [showPwd2, setShowPwd2] = useState(false);

  const trimLower = (s) => (s || '').trim().toLowerCase();

  const validar = () => {
    const e = { email: '', password: '', confirmar: '', horas: '', general: '' };

    // Email
    const em = trimLower(email);
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(em)) e.email = 'Correo inválido';

    // Password (>=8 y al menos un dígito)
    if (password.length < 8) {
      e.password = 'La contraseña debe tener al menos 8 caracteres';
    } else if (!/\d/.test(password)) {
      e.password = 'La contraseña debe incluir al menos un número';
    }

    // Confirmación
    if (confirmar !== password) e.confirmar = 'Las contraseñas no coinciden';

    // Horas semanales (opcional)
    if (String(horasSemanales).trim() !== '') {
      const h = Number(String(horasSemanales).replace(',', '.'));
      if (!Number.isFinite(h) || h < 1 || h > 80) {
        e.horas = 'Horas semanales inválidas (1-80)';
      }
    }

    setErrors(e);
    return !Object.values(e).some(Boolean);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (enviando) return;
    if (!validar()) return;

    setEnviando(true);
    setErrors((prev) => ({ ...prev, general: '' }));
    try {
      const payload = {
        email: trimLower(email),
        password,
        role: rol,
        // ✅ solo mandamos si están rellenos
        ...(nombre.trim()    ? { nombre: nombre.trim() }       : {}),
        ...(apellido1.trim() ? { apellido1: apellido1.trim() } : {}),
        ...(apellido2.trim() ? { apellido2: apellido2.trim() } : {}),
        ...(String(horasSemanales).trim() !== ''
          ? { horas_semanales_pactadas: Number(String(horasSemanales).replace(',', '.')) }
          : {}),
      };

      await onCrearUsuario(payload);

      // Reset suave tras éxito
      setEmail('');
      setPassword('');
      setConfirmar('');
      setRol('employee');
      setNombre('');
      setApellido1('');
      setApellido2('');
      setHorasSemanales('');
    } catch (err) {
      setErrors((prev) => ({
        ...prev,
        general: err?.message || 'No se pudo crear el usuario',
      }));
    } finally {
      setEnviando(false);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="bg-white p-6 rounded-2xl shadow-sm border border-gray-200 space-y-5"
      noValidate
    >
      <h3 className="text-xl font-bold text-blue-900">➕ Registrar nuevo usuario</h3>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Email */}
        <div className="flex flex-col">
          <label htmlFor="uf-email" className="text-xs text-gray-600 mb-1">Correo electrónico</label>
          <input
            id="uf-email"
            type="email"
            placeholder="nombre@empresa.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoComplete="email"
            className={`border rounded-xl px-4 py-2 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 transition ${
              errors.email ? 'border-red-400' : 'border-gray-300'
            }`}
          />
          {errors.email && <span className="mt-1 text-xs text-red-600">{errors.email}</span>}
        </div>

        {/* Rol */}
        <div className="flex flex-col">
          <label htmlFor="uf-rol" className="text-xs text-gray-600 mb-1">Rol</label>
          <select
            id="uf-rol"
            value={rol}
            onChange={(e) => setRol(e.target.value)}
            className="border border-gray-300 rounded-xl px-4 py-2 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
          >
            <option value="employee">Empleado</option>
            <option value="admin">Administrador</option>
          </select>
        </div>

        {/* Password */}
        <div className="flex flex-col">
          <label htmlFor="uf-pass" className="text-xs text-gray-600 mb-1">Contraseña</label>
          <div className="relative">
            <input
              id="uf-pass"
              type={showPwd ? 'text' : 'password'}
              placeholder="Mínimo 8 caracteres y un número"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="new-password"
              className={`w-full border rounded-xl px-4 py-2 pr-10 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 transition ${
                errors.password ? 'border-red-400' : 'border-gray-300'
              }`}
            />
            <button
              type="button"
              onClick={() => setShowPwd((v) => !v)}
              className="absolute right-2 top-1/2 -translate-y-1/2 text-sm text-gray-500 hover:text-gray-700"
              aria-label={showPwd ? 'Ocultar contraseña' : 'Mostrar contraseña'}
              title={showPwd ? 'Ocultar' : 'Mostrar'}
            >
              {showPwd ? '🙈' : '👁️'}
            </button>
          </div>
          {errors.password && <span className="mt-1 text-xs text-red-600">{errors.password}</span>}
        </div>

        {/* Confirmar */}
        <div className="flex flex-col">
          <label htmlFor="uf-pass2" className="text-xs text-gray-600 mb-1">Confirmar contraseña</label>
          <div className="relative">
            <input
              id="uf-pass2"
              type={showPwd2 ? 'text' : 'password'}
              placeholder="Repite la contraseña"
              value={confirmar}
              onChange={(e) => setConfirmar(e.target.value)}
              required
              autoComplete="new-password"
              className={`w-full border rounded-xl px-4 py-2 pr-10 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 transition ${
                errors.confirmar ? 'border-red-400' : 'border-gray-300'
              }`}
            />
            <button
              type="button"
              onClick={() => setShowPwd2((v) => !v)}
              className="absolute right-2 top-1/2 -translate-y-1/2 text-sm text-gray-500 hover:text-gray-700"
              aria-label={showPwd2 ? 'Ocultar confirmación' : 'Mostrar confirmación'}
              title={showPwd2 ? 'Ocultar' : 'Mostrar'}
            >
              {showPwd2 ? '🙈' : '👁️'}
            </button>
          </div>
          {errors.confirmar && <span className="mt-1 text-xs text-red-600">{errors.confirmar}</span>}
        </div>
      </div>

      {/* ✅ Datos opcionales */}
      <fieldset className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <legend className="col-span-1 md:col-span-4 text-sm font-semibold text-gray-700">Datos opcionales</legend>
        <div className="flex flex-col">
          <label htmlFor="uf-nombre" className="text-xs text-gray-600 mb-1">Nombre</label>
          <input
            id="uf-nombre"
            value={nombre}
            onChange={(e) => setNombre(e.target.value)}
            placeholder="Ej. Ana"
            className="border border-gray-300 rounded-xl px-4 py-2 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
          />
        </div>
        <div className="flex flex-col">
          <label htmlFor="uf-ap1" className="text-xs text-gray-600 mb-1">Primer apellido</label>
          <input
            id="uf-ap1"
            value={apellido1}
            onChange={(e) => setApellido1(e.target.value)}
            placeholder="Ej. García"
            className="border border-gray-300 rounded-xl px-4 py-2 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
          />
        </div>
        <div className="flex flex-col">
          <label htmlFor="uf-ap2" className="text-xs text-gray-600 mb-1">Segundo apellido</label>
          <input
            id="uf-ap2"
            value={apellido2}
            onChange={(e) => setApellido2(e.target.value)}
            placeholder="Ej. López"
            className="border border-gray-300 rounded-xl px-4 py-2 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
          />
        </div>
        <div className="flex flex-col">
          <label htmlFor="uf-horas" className="text-xs text-gray-600 mb-1">Horas semanales (opc.)</label>
          <input
            id="uf-horas"
            type="number"
            min="1"
            max="80"
            step="0.5"
            value={horasSemanales}
            onChange={(e) => setHorasSemanales(e.target.value)}
            placeholder="Ej. 40"
            className={`border rounded-xl px-4 py-2 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 transition ${
              errors.horas ? 'border-red-400' : 'border-gray-300'
            }`}
          />
          {errors.horas && <span className="mt-1 text-xs text-red-600">{errors.horas}</span>}
        </div>
      </fieldset>

      {/* Error general */}
      {errors.general && <div className="text-sm text-red-600">{errors.general}</div>}

      <button
        type="submit"
        disabled={enviando}
        className="bg-blue-700 hover:bg-blue-800 transition-all duration-200 text-white px-6 py-2 rounded-xl font-semibold flex items-center justify-center gap-2 disabled:opacity-50"
      >
        {enviando ? (
          <>
            <svg className="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24" aria-hidden>
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"/>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 100 16 8 8 0 01-8-8z"/>
            </svg>
            Creando...
          </>
        ) : (
          'Crear usuario'
        )}
      </button>

      {msg && <p className="text-sm text-gray-700">{msg}</p>}
    </form>
  );
}
